import { EMPTY_HUNGER, FULL_HUNGER, VW } from "../../../../tiles";
import { GlyphBar } from "../../../../ui/dataInfo/GlyphBar";
import { ComponentF, createElement } from "../../../../ui/ui";
import Colors from "../../../Colors";
import { gameData } from "../../../GameManager";
import { FLOURISH_WIDTH } from "../SpellWand";

export const HungerBar: ComponentF<void> = (C) => {
  const x = VW / 2 + (gameData.player.maxLetters + FLOURISH_WIDTH) / 2 + 2;
  return [
    createElement(
      GlyphBar,
      { x: x, y: 0, w: 10, h: 1 },
      {
        full: FULL_HUNGER,
        empty: EMPTY_HUNGER,
        current: gameData.player.hunger.current,
        max: gameData.player.hunger.max,
        fullColor: Colors.SEA_GREEN_4,
      }
    ),
  ];
};
